import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=634b42c9&"
import script from "./PersonalCenter.vue?vue&type=script&lang=ts&"
export * from "./PersonalCenter.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports